import JSONModel from "sap/ui/model/json/JSONModel";
import BaseController from "../controller/BaseController";
import { EnvironmentService } from "../service/Environment.service";
import { Finanzauskunft } from "../model/models";
import { ErrorHandler } from "../service/ErrorHandler.service";

module Finanzdata {
  export type FinanzRow = { group: string; label: string; value1?: number; value2?: number; value3?: number };
}

export default class FinanzauskunftBlock extends BaseController {
  private _finanzauskunftModel: JSONModel;

  onInit(): void {
    this.getView().attachModelContextChange(null, this.onModelContextChange);
    this._finanzauskunftModel = new JSONModel([]);
    this.setModel(this._finanzauskunftModel);
  }

  onModelContextChange = async (oEvent: Event) => {
    this._loadData();
  };

  private _loadData = async () => {
    const oCustomerModel = this.getModel("Customer");
    this._finanzauskunftModel.setData([]);
    if (oCustomerModel) {
      try {
        const kundId = oCustomerModel.getProperty("/id");
        if (!!kundId) {
          const finanzauskunft: Finanzauskunft = await $.getJSON(`${EnvironmentService.getBaseUrl()}/kunde/${kundId}/finanzauskunft`);
          const listitems = this._toListItems(finanzauskunft);
          this._finanzauskunftModel.setData(listitems);
        }
      } catch (ex: any) {
        ErrorHandler.handleError(ex, { title: "Fehler beim Laden der Finanzauskunft", ignorable: true, onRetry: this._loadData });
      }
    }
  };

  private _toListItems = (f: Finanzauskunft): Array<Finanzdata.FinanzRow> => {
    const arr: Array<Finanzdata.FinanzRow> = [];

    if (!!f.label1 && !!f.wert1) arr.push(this._getListItem("Finanzauskunft", f.label1, f.wert1));
    if (!!f.label2 && !!f.wert2) arr.push(this._getListItem("Finanzauskunft", f.label2, f.wert2));
    if (!!f.label3 && !!f.wert3) arr.push(this._getListItem("Finanzauskunft", f.label3, f.wert3));
    if (!!f.label4 && !!f.wert4) arr.push(this._getListItem("Finanzauskunft", f.label4, f.wert4));
    if (!!f.label5 && !!f.wert5) arr.push(this._getListItem("Finanzauskunft", f.label5, f.wert5));
    if (!!f.label6 && !!f.wert6) arr.push(this._getListItem("Finanzauskunft", f.label6, f.wert6));
    if (!!f.label7 && !!f.wert7) arr.push(this._getListItem("Finanzauskunft", f.label7, f.wert7));
    if (!!f.label8 && !!f.wert8) arr.push(this._getListItem("Finanzauskunft", f.label8, f.wert8));
    if (!!f.label9 && !!f.wert9) arr.push(this._getListItem("Finanzauskunft", f.label9, f.wert9));

    if (!!f.label10 && !!f.wert10) arr.push({ group: "Offene Posten", label: f.label10, value1: f.wert10 });
    if (!!f.label11 && !!f.wert11) arr.push({ group: "Offene Posten", label: f.label11, value1: f.wert11 });
    if (!!f.label12 && !!f.wert12) arr.push({ group: "Offene Posten", label: f.label12, value1: f.wert12 });
    if (!!f.label13 && !!f.wert13) arr.push({ group: "Offene Posten", label: f.label13, value1: f.wert13 });
    arr.push({ group: "Offene Posten", label: "Gesamtsumme", value1: f.offenePostenGesamt });

    arr.push({ group: "Limit", label: "Kreditlimit", value1: f.kreditlimit });
    arr.push({ group: "Limit", label: "Kredit-Versicherung", value1: f.kreditversicherung });
    arr.push({ group: "Limit", label: "Finanzauskunft Gesamt", value1: f.finanzauskunftGesamt });
    arr.push({ group: "Limit", label: "Freies Limit", value1: f.freiesLimit });

    return arr;
  };

  private _getListItem(group: string, label: string, value: number): Finanzdata.FinanzRow {
    return label.startsWith("---") ? { group: group, label: label } : { group: group, label: label, value1: value };
  }
}
